import { render, staticRenderFns } from "./register-event.html?vue&type=template&id=7f907d1c&"
import script from "./register-event.js?vue&type=script&lang=js&"
export * from "./register-event.js?vue&type=script&lang=js&"
import style0 from "./register-event.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports